import * as React from "react";
import star from "../../../../assets/images/common/star.svg";
import { useHistory } from "react-router";
import { paramCase } from "change-case";
import { IImages } from "api/recipes/type";
import { useOptimizerImage } from "utils/useOptimizerImage";

export interface IRecipe {
  _id: string;
  images: IImages;
  title: string;
  avgRating: number;
  calories: number;
  servings: number;
}

export interface IRecipeCardProps extends IRecipe {
  className?: string;
}

export function RecipeCard(props: IRecipeCardProps) {
  const {
    _id,
    avgRating,
    calories,
    images,
    title,
    className,
    servings,
  } = props;

  const history = useHistory();
  const goRecipeInfoPage = () => {
    const titleSlug = paramCase(title);
    history.push(`/recipes/${titleSlug}`);
  };

  const optimizedImageLink = useOptimizerImage({
    common: images?.vertical,
    retina: images?.verticalX2,
  });

  return (
    <div className={`recipe-card-main embla__slide recipe ${className ?? ""}`}>
      <div
        className="recipe-image"
        style={
          images?.vertical ? optimizedImageLink : { backgroundColor: "#eeeeee" }
        }
        onClick={goRecipeInfoPage}
      >
        <div className="recipe-content">
          <h4 className="recipe-title">{title}</h4>
          <div className="recipe-info">
            <span className="recipe-rating">
              <img src={star} alt={"rating"} />
              {avgRating.toFixed()}
            </span>{" "}
            | <span>{(calories / servings).toFixed()} cal</span>
          </div>
        </div>
      </div>
    </div>
  );
}
